module.exports = __webpack_public_path__ + "static/img/iconBilquis.f8b907a.svg";


//////////////////
// WEBPACK FOOTER
// ./static/svg/iconBilquis.svg
// module id = 5Awi
// module chunks = 1